import { AutogenLayoutChargeCodeQuickInfo } from "./autogen/AutogenLayoutChargeCodeQuickInfo"

export class ChargeCodeQuickInfo extends AutogenLayoutChargeCodeQuickInfo {
}